import { Injectable } from '@angular/core';
import { LoginService } from '../../login/login.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject } from 'rxjs';
import { ArticulosGuardados, ResponseCart } from '../../../core/model/DataCart';
import { DataAddCart, ProductData } from '../../../core/model/Product.model';
import { DataUser } from '../../../models/generar_pedido/DataUser';
import { map, retry } from 'rxjs/operators';
import { EmpresaService } from '../../Empresa/Empresa.service';

@Injectable({
  providedIn: 'root'
})
export class ArticulosGuardadosService {
  empresaId: string;

  constructor(private loginService: LoginService,
    //private spinner: LoadingService,
    private http: HttpClient,
    private empresaService: EmpresaService
  ) {
    this.empresaService.empresaId$.subscribe(id => {
      this.empresaId = id;
    });
  }

  private apiUrl = environment.apiUrl;
  public articulosGuardados = new BehaviorSubject<ArticulosGuardados[]>([]);
  public artGuardados: ArticulosGuardados[] = [];

  articulosGuardados$ = this.articulosGuardados.asObservable();

  updateArtGurdados$ = (artGuardados$: ArticulosGuardados[]): void => {
    this.artGuardados = [];
    this.articulosGuardados.next(this.artGuardados);
    this.artGuardados = artGuardados$;
    // console.log('this.artGuardados',this.artGuardados);
    this.articulosGuardados.next(this.artGuardados);
  }

  public addNewItemArt = (item: DataAddCart, productData?: ProductData) => {
    const dataCliente = this.loginService.getDataClientePedido();
    const dataquery = {
      // p : environment.production,
      article_id: item.ClaveArticulo,
      qty: item.Cantidad,
      client_id: dataCliente.client_number,
      almacen_id: item.AlmacenID,
      empresa_id: this.empresaId,
      uid: dataCliente.uid,
      publicoGeneral: dataCliente.es_publicogeneral,
      correo: dataCliente.email,
      option: 'addArticulo',
      isCedis: item.isCedis,
      productData
    };
    return this.http.post<any>(this.apiUrl + 'Servicios-web/Cart/ArticulosGuardados.php', dataquery).pipe(map((response) => response));
  }

  public getArticulosGuardados = () => {
    const cliente: DataUser = this.loginService.getDataClientePedido();
    const dataQuery = {
      // p : environment.production,
      client_id: cliente.client_number,
      empresa_id: this.empresaId,
      almacen_id: cliente.almacenPre,
      uid: cliente.uid,
      publicoGeneral: cliente.es_publicogeneral,
      correo: cliente.email,
      option: 'getArticulo',
    };
    return this.http
      .post<ResponseCart>(
        this.apiUrl + 'Servicios-web/Cart/ArticulosGuardados.php',
        dataQuery
      )
      .pipe(
        retry(3),
        map((res) => {
          if (res.error === false) {
            this.articulosGuardados.next([]);
            this.articulosGuardados.next(res.articulosGuardados);
          }
          return res;
        })
      );
  };

  public removeItemToArticuloGuardado = (item: ProductData) => {
    const cliente: DataUser = this.loginService.getDataClientePedido();
    const article = {
      // p : environment.production,
      article_id: item.ClaveArticuloProveedor,
      client_id: cliente.client_number,
      empresa_id: this.empresaId,
      almacen_id: cliente.almacenPre,
      cedis: item.isCedis,
      // publico en general
      uid: cliente.uid,
      publicoGeneral: cliente.es_publicogeneral,
      correo: cliente.email,
      option: 'delArticuloGuardado',
    };
    return this.http
      .post<ResponseCart>(this.apiUrl + 'Servicios-web/Cart/ArticulosGuardados.php', article)
      .pipe(
        map((response) => {
          if (!response.error) {
            //this.getArticulosGuardados();
            // this.deleteItemCart$(item);
          }
          return response;
        })
      );
  };
}
